module.exports = __webpack_public_path__ + "media/images/thumbs/atlas/vfcleg6-80c3f877d5c623110711142ea2085408.jpg";